import { render, staticRenderFns } from "./ConfirmDelete.vue?vue&type=template&id=2d4f2e06"
import script from "./ConfirmDelete.vue?vue&type=script&lang=js"
export * from "./ConfirmDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports